import React from "react";
import GatsbyConfig from "../../../gatsby-config.js";
import { setInLocal, getParamFromQueryString } from "../../utils/app-helpers";
import SiteFooter from "../partials/site-footer";
import HelmetWrapper from "../partials/helmet-wrapper";
import SiteHeader from "../partials/site-header";

const { siteMetadata: config } = GatsbyConfig;

export default class PayErrorPage extends React.Component {
  componentDidMount() {
    const { trip } = this.props;

    setInLocal("lsg.last-viewed-trip", trip);
  }

  render() {
    if (typeof window === "undefined") return <div />;
    const { trip } = this.props;
    let error = {};

    try {
      const e = getParamFromQueryString("e", window.location.href);
      error = typeof e === "string" ? JSON.parse(e) : e;
      if (typeof error === "string") error = JSON.parse(error);
    } catch (e) {}
    return (
      <div className={`page-pay-error trip-${trip}`}>
        <SiteHeader trip={trip} />
        <main>
          <div className="wrap">
            <div className="content centered">
              <h1>Payment Error</h1>
              <h3>
                Your transaction could not be processed. <br />
                {error.code !== "customer_max_subscriptions"
                  ? "Please contact your bank or try another credit card."
                  : ""}
              </h3>
              {error.message ? (
                <div>
                  <hr />
                  <p className="error">{error.message}</p>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </main>
        <SiteFooter trip={trip} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/pay-error.js